




































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { Student as IStudent } from "@/api-v2/course/models";
import { courseApi, studentDocumentApi } from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import { Student as IStudentDocInfo } from "@/api-v2/student-document-info/models";
import { Passport as IPassport } from "@/api-v2/student-document-info/models/passport";
import UserAvatar from "@/components/user/UserAvatar.vue";
import learningRequests, {
  LearningRequestsListParamsV2
} from "@/getinfo-api/learningRequestsV2";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { currentUserIsCompanyOwner, isRoot } from "@/plugins/roles";
import { LearningRequestSort, SortFields } from "@/plugins/sort-fields";
import {
  consentModule,
  quickDocumentCreationModule
} from "@/plugins/modules-detect";
import { LearningRequest as ILearningRequest } from "@/api/models";
import StudentOrderItemPreview from "@/components/students/StudentOrderItemPreview.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { UsersListClass } from "@/classes/list/UsersListClass";
import CField from "@/components/form/CField.vue";

@Component({
  components: {
    CField,
    CSingleSelect,
    StudentOrderItemPreview,
    CustomButton,
    CustomTable,
    OrderItemPreview,
    UserAvatar,
    TextField,
    CBlock,
    CPage
  }
})
export default class Student extends Vue {
  usersList: UsersListClass = new UsersListClass({});
  student!: IStudent;
  isLoading: boolean = false;
  studentDocumentInfo!: IStudentDocInfo;
  passport!: IPassport;
  orders!: any;
  requestCount!: number;
  limit: number = 30;
  offset: number = 0;
  sorted: SortFields<LearningRequestSort> = new SortFields(
    LearningRequestSort.formedAt
  );
  checkedRequests: ILearningRequest[] = [];
  number: string | undefined;

  data() {
    return {
      number: undefined,
      orders: undefined,
      passport: undefined,
      studentDocumentInfo: undefined,
      student: undefined,
      requestCount: undefined
    };
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return currentUserIsCompanyOwner();
  }

  get learningManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  get sortStatus() {
    return LearningRequestSort;
  }

  get isConsentModuleEnabled() {
    return consentModule();
  }

  get isQuickDocumentCreation() {
    return quickDocumentCreationModule();
  }

  get fullName() {
    return this.student
      ? `${this.student.lastName} ${this.student.firstName} ${
          this.student.middleName ? this.student.middleName : ""
        }`
      : "";
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "students" },
        label: this.$tc(this.$translate.Students)
      },
      {
        label: this.fullName
      }
    ];
  }

  selectRequest(request: ILearningRequest) {
    this.checkedRequests.includes(request)
      ? (this.checkedRequests = this.checkedRequests.filter(
          el => el !== request
        ))
      : this.checkedRequests.push(request);
  }

  acceptSort(sort: LearningRequestSort) {
    this.sorted.changeSort(sort);
    this.applyFilter();
  }

  applyFilter() {
    this.orders = [];
    this.offset = 0;
    this.getOrdersByStudent(this.offset);
  }

  getOrdersByStudent(offset: number = 0) {
    try {
      this.isLoading = true;
      let params: LearningRequestsListParamsV2 = {
        companyId: this.student.companyId,
        studentIds: [this.student.id],
        limit: this.limit,
        offset: offset
      };
      learningRequests(params).then(res => {
        this.orders = res.data.items;
        this.requestCount = res.data.count;
      });
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  showMore() {
    this.offset += this.limit;
    this.getOrdersByStudent(this.offset);
  }

  translateGender() {
    if (this.student.gender) {
      if (this.student.gender === "male") {
        return this.$tc(this.$translate.Male);
      } else {
        return this.$tc(this.$translate.Female);
      }
    }
    return this.$tc(this.$translate.NotSelected);
  }

  //ПОЛУЧАЮ ТЕКУЩЕГО СТУДЕНТА
  async getCurrentStudent() {
    this.isLoading = true;
    await courseApi.Student.getStudent(this.$route.params.id)
      .then(async res => {
        this.student = res.data;
        const { data } = await studentDocumentApi.getStudent(this.student?.id);
        this.studentDocumentInfo = data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async created() {
    await this.getCurrentStudent();
    await this.getOrdersByStudent();
  }
}
